import { render, staticRenderFns } from "./PurpleButton.vue?vue&type=template&id=2e8299a8&scoped=true&"
import script from "./PurpleButton.vue?vue&type=script&lang=js&"
export * from "./PurpleButton.vue?vue&type=script&lang=js&"
import style0 from "./PurpleButton.vue?vue&type=style&index=0&id=2e8299a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8299a8",
  null
  
)

export default component.exports